export type DataMode = "demo" | "persistent";

export interface DataModeInput {
  dataMode?: string;
  useMocks?: string;
}

/**
 * Keeps the old VITE_USE_MOCKS flag working while making the mode explicit.
 * An explicit data mode and legacy flag must always describe the same mode.
 */
export function resolveDataMode({ dataMode, useMocks }: DataModeInput): DataMode {
  if (dataMode !== undefined && dataMode !== "demo" && dataMode !== "persistent") {
    throw new Error('VITE_DATA_MODE deve ser "demo" ou "persistent".');
  }
  if (useMocks !== undefined && useMocks !== "true" && useMocks !== "false") {
    throw new Error('VITE_USE_MOCKS deve ser "true" ou "false".');
  }

  const legacyMode: DataMode | undefined =
    useMocks === undefined ? undefined : useMocks === "true" ? "demo" : "persistent";
  const resolved: DataMode = dataMode ?? legacyMode ?? "demo";

  if (legacyMode && dataMode && legacyMode !== dataMode) {
    throw new Error(
      "Configuração contraditória: VITE_DATA_MODE e VITE_USE_MOCKS precisam indicar o mesmo modo.",
    );
  }
  return resolved;
}
